import { sendEventToJumbo } from './jumbo';

export const MAP_EVENTS = {
  GET_MAP_DETAILS_SUCCESS: 'get_map_details_success',
  GET_MAP_DETAILS_FAILURE: 'get_map_details_failure',
  RELOAD_MAP_EVENT: 'reload_map_event',
};

export const sendMapApiEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};

export const sendReloadMapEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};

export const sendMerchantModalEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};
